'use client';

import { useModalState } from './useModalState';

export interface UseLayoutMobileStateReturn {
  mobileSearch: ReturnType<typeof useModalState>;
  mobileMenuDrawer: ReturnType<typeof useModalState>;
}

/**
 * Manages mobile-specific UI state (search bar, menu drawer).
 */
export const useLayoutMobileState = (): UseLayoutMobileStateReturn => {
  const mobileSearch = useModalState(false);
  const mobileMenuDrawer = useModalState(false);

  return {
    mobileSearch,
    mobileMenuDrawer,
  };
};
